import { Interpolation, Theme } from '@emotion/react';
import { observer } from 'mobx-react-lite';

import gameIcon from '#/gameicon.png';
import {
  absolute,
  border,
  borderRadius,
  colors,
  dropShadow,
  flexCenterVertical,
  font,
  relative,
  StrokeText,
  noSelect,
} from '@toilet-paper-games/ui';
import { FrontendFonts } from '../styles/fonts';

export interface GameIconButtonProps
  extends React.ClassAttributes<HTMLButtonElement>,
    React.HTMLAttributes<HTMLButtonElement> {
  className?: string;
  uniqueName: string;
  image?: string;
  title: string;
  onClick?: () => void;
}

const buttonStyle: (image?: string) => Interpolation<Theme> = (image) => [
  {
    cursor: 'pointer',
    border: 'none',
    color: colors.text,
    fontWeight: 600,
    transition: 'all 0.2s',
    minWidth: 128,
    aspectRatio: 1,
    backgroundColor: colors.componentSolid,
    backgroundImage: `url(${image ?? gameIcon})`,
    WebkitTapHighlightColor: 'transparent',
    userSelect: 'none',
    MozUserSelect: 'none',
    backgroundSize: 'contain',
    '&:active': {
      filter: 'brightness(80%)',
      transform: 'scale(0.95)',
      '&>img': {
        filter: 'brightness(100%)',
      },
    },
    '&:hover,&:focus': {
      color: colors.accent,
      borderColor: colors.primary,
      filter: 'brightness(110%)',
      '&>img': {
        filter: 'brightness(100%)',
      },
    },
  },
  flexCenterVertical,
  borderRadius(16),
  border('#24292d', '6px'),
  dropShadow(3),
  relative(),
  noSelect,
];

const textStyle: Interpolation<Theme> = [
  {
    lineHeight: 1,
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  absolute(undefined, undefined, 10, 10),
  font(FrontendFonts['Bebas Neue'], `1.6em`, 4),
];

export const GameIconButton = observer((props: GameIconButtonProps) => {
  const { image, title, uniqueName, onClick, ...rest } = props;

  return (
    <button css={buttonStyle(image)} onClick={onClick} {...rest}>
      <StrokeText css={textStyle} strokeColor={'#0009'}>
        {title}
      </StrokeText>
    </button>
  );
});
